import {
  CopyOutlined,
  EditOutlined,
  EyeOutlined,
  InfoCircleOutlined,
  MessageOutlined,
  ReloadOutlined,
  UploadOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Space,
  Tag,
  Tooltip,
  Typography,
  message
} from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useHistory } from 'react-router-dom';
// import { CONFIG } from '../constants';
import { CONFIG } from '../constants';
import UserContext from '../context/user-context';
import { errorHandler, estadosSolicitud, toUpperCase } from '../utils';
import { instanceRef } from '../utils/axios';
import { formatoMonedaGenerico } from '../utils/converters';
import { fieldTypes, filterConditions } from '../utils/filter-utils';
import ResponsiveContainer from './ResponsiveContainer';
import TableAndFilters from './TableAndFilters';

const styles = {
  menuAction: {
    marginLeft: 10
  }
};

function SolicitudList() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const tableRef = useRef();
  const { user } = useContext(UserContext);
  const history = useHistory();
  const [loading, setLoading] = useState();
  const [loadingMasiva, setLoadingMasiva] = useState(false);
  const [poliza, setPoliza] = useState();
  const [tokenEnviar, setTokenEnviar] = useState();
  const [visiblePolizaMasiva, setVisiblePolizaMasiva] = useState(false);
  const [visibleAprobarExtranjeros, setVisibleAprobarExtranjeros] = useState(
    false
  );
  const [formPolizaMasiva] = Form.useForm();
  const [formAprobarExtranjeros] = Form.useForm();
  const [columns, setColumns] = useState([]);
  const [defaultFilters, setDefaultFilters] = useState({
    'poliza.id_poliza_masiva': {
      value: 'null',
      filterType: fieldTypes.STRING,
      filterCondition: filterConditions.EQUALS
    }
  });

  const showModalPolizaMasiva = () => {
    setVisiblePolizaMasiva(true);
  };

  const showModalAprobarExtranjeros = () => {
    setVisibleAprobarExtranjeros(true);
  };

  const handleCancelAprobarExtranjeros = async () => {
    setVisibleAprobarExtranjeros(false);
  };

  const handleCancelPolizaMasiva = async () => {
    setVisiblePolizaMasiva(false);
  };

  const handleOkPolizaMasiva = async () => {
    setLoadingMasiva(true);
    try {
      const nroLote = formPolizaMasiva.getFieldValue('numero_lote');
      await instanceRef.instance.post(`proceso/altaPolizaMasiva`, {
        polizaMasivaId: nroLote
      });
      message.success(`Procesando Poliza Masiva`);
      setLoadingMasiva(false);
      setVisiblePolizaMasiva(false);
    } catch (error) {
      setLoadingMasiva(false);
      errorHandler(error);
    }
  };

  const handleOkAprobarExtranjeros = async () => {
    setLoadingMasiva(true);
    try {
      const nroLote = formAprobarExtranjeros.getFieldValue('numero_lote');
      await instanceRef.instance.post(`proceso/aprobacionPolizaMasiva`, {
        polizaMasivaId: nroLote,
        aprobarExtranjeros: true
      });
      message.success(`Procesando Poliza Masiva para extranjeros`);
      setLoadingMasiva(false);
      setVisibleAprobarExtranjeros(false);
    } catch (error) {
      setLoadingMasiva(false);
      errorHandler(error);
    }
  };

  const generarPoliza = async (record) => {
    setLoading(true);
    setTokenEnviar(record.token);
    const reCaptchaToken = await executeRecaptcha('poliza/emision');

    try {
      const response = await instanceRef.instance.post(`poliza/emision`, {
        reCaptchaToken,
        token: record.poliza.token,
        error: record.mensaje
      });
      setPoliza(response);
      if (poliza && poliza.numero) {
        if (poliza.sebaot_link_documentos) {
          message.success('¡Póliza aprobada!');
        } else {
          message.success('¡La solicitud de póliza se está procesando!');
        }

        history.push(`/polizas/${poliza.token}`);
      }

      message.error('Error al generar la Póliza');
      setLoading(false);
      return null;
    } catch (error) {
      message.error('Error al generar la Póliza');
      setLoading(false);
      return error;
    }
  };
  const aprobarPoliza = async (record) => {
    setLoading(true);
    setTokenEnviar(record.token);
    const reCaptchaToken = await executeRecaptcha('poliza/emision');

    try {
      let error;
      if (record.mensaje) {
        error = record.mensaje;
      }

      const response = await instanceRef.instance.post(`poliza/emision`, {
        reCaptchaToken,
        token: record.poliza.token,
        error
      });
      setPoliza(response);
      if (
        poliza &&
        (poliza.estado === 'APROBADO' || poliza.estado === 'VIGENTE')
      ) {
        message.success('¡Póliza aprobada!');
        history.push(`/polizas/${poliza.token}`);
      }

      message.error('Error al aprobar la Póliza');
      setLoading(false);
      return null;
    } catch (error) {
      message.error('Error al aprobar la Póliza');
      setLoading(false);
      return error;
    }
  };

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  const getButton = (record) => {
    let mensajeVerificar = '';
    let proceso = '';
    if (record.mensaje) {
      const error = record.mensaje?.split('::');
      mensajeVerificar = error[1].toString();
      proceso = error[2].toString();
    }
    if (
      user['cognito:groups'][0] === 'ADMIN' &&
      record.tipo === 'MASIVA' &&
      record.estado === 'VERIFICAR'
    ) {
      return (
        <Tooltip title="Editar solicitud">
          <Button
            type="text"
            icon={<EditOutlined />}
            size="middle"
            onClick={() => handleOpenUrl(`solicitud/edit/${record.token}`)}
          />
        </Tooltip>
      );
    }
    if (
      record.estado === 'VERIFICAR' &&
      (mensajeVerificar.includes('BCP') ||
        proceso.includes('BCP') ||
        mensajeVerificar.includes('chapa') ||
        proceso.includes('chapa') ||
        mensajeVerificar.includes('Asegurado') ||
        proceso.includes('Asegurado'))
    ) {
      return (
        <Tooltip title="Editar solicitud">
          <Button
            type="text"
            icon={<EditOutlined />}
            size="middle"
            onClick={() => handleOpenUrl(`solicitud/${record.token}`)}
          />
        </Tooltip>
      );
    }
    if (
      record.estado === 'AUTORIZACION' &&
      (user['cognito:groups'][0] === 'ADMIN' ||
        user['cognito:groups'][0] === 'ADMIN_ASEGURADORA')
    ) {
      return (
        <Tooltip title="Editar solicitud">
          <Button
            type="text"
            icon={<EditOutlined />}
            size="middle"
            onClick={() => handleOpenUrl(`solicitud/${record.token}`)}
          />
        </Tooltip>
      );
    }
    return (
      <Tooltip title="Ver solicitud">
        <Button
          type="text"
          icon={<EyeOutlined />}
          size="middle"
          onClick={() => handleOpenUrl(`solicitudes/${record.token}`)}
        />
      </Tooltip>
    );
  };

  const sendSms = async (record, empresa) => {
    try {
      const reCaptchaToken = await executeRecaptcha('sms/firmar');
      const data = {
        reCaptchaToken,
        persona: {
          celular: record.cotizacion.persona.celular
        },
        token: record.token,
        idEmpresa: record.cotizacion.aseguradoraEmpresa.id_empresa
      };
      const viaWhatsapp =
        empresa.tiene_whatsapp &&
        record.cotizacion.persona.via_contacto === 'whatsapp';
      message.info(
        `${record.cotizacion.persona.celular} recibirá un mensaje de ${
          viaWhatsapp ? 'Whatsapp' : 'texto'
        } para firmar el documento`
      );
      await instanceRef.instance.post(`sms/firmar`, data);
    } catch (error) {
      // error
    }
  };

  const sendMail = async (record) => {
    try {
      const reCaptchaToken = await executeRecaptcha('mail/firmar');
      const data = {
        reCaptchaToken,
        persona: {
          correo: record.cotizacion.persona.correo
        },
        token: record.token,
        idEmpresa: record.cotizacion.aseguradoraEmpresa.id_empresa
      };
      message.info(
        `${record.cotizacion.persona.correo} recibirá un correo para firmar el documento`
      );
      await instanceRef.instance.post(`mail/firmar`, data);
    } catch (error) {
      // error
    }
  };

  useEffect(() => {
    const esAdminAseguradora =
      user && user['cognito:groups'][0] === 'ADMIN_ASEGURADORA';
    const esAdmin = user && user['cognito:groups'][0] === 'ADMIN';
    const columnas = [
      {
        title: 'ID',
        dataIndex: 'id',
        width: '10px',
        filterType: fieldTypes.NUMERIC,
        sortable: true
      },
      {
        title: 'Fecha',
        dataIndex: 'fecha',
        filterType: fieldTypes.DATETIME,
        sortable: true,
        width: '30%'
      },
      {
        title: 'Cliente',
        dataIndex: ['cotizacion', 'persona', 'nombres'],
        filterType: fieldTypes.STRING,
        sortable: true,
        width: '20%'
      },

      {
        title: 'Producto',
        dataIndex: ['cotizacion', 'producto', 'descripcion'],
        width: '20%',
        filterType: fieldTypes.STRING,
        sortable: true
      },
      ...(esAdminAseguradora
        ? [
            {
              title: 'Corredora',
              dataIndex: [
                'cotizacion',
                'aseguradoraEmpresa',
                'empresa',
                'ec',
                'nombre'
              ],
              width: '10%',
              filterType: fieldTypes.STRING,
              sortable: true
            },
            {
              title: 'Empresa',
              dataIndex: [
                'cotizacion',
                'aseguradoraEmpresa',
                'empresa',
                'nombre'
              ],
              width: '10%',
              filterType: fieldTypes.STRING,
              sortable: true
            }
          ]
        : []),
      ...(esAdmin
        ? [
            {
              title: 'Aseguradora',
              dataIndex: [
                'cotizacion',
                'aseguradoraEmpresa',
                'aseguradora',
                'descripcion'
              ],

              filterType: fieldTypes.STRING,
              sortable: true
            }
          ]
        : []),
      {
        title: 'Ejecutivo',
        dataIndex: ['cotizacion', 'usuarioVendedor'],
        key: 'cotizacion.usuarioVendedor.nombres',
        render: (usuarioVendedor) => {
          let nombres = '';
          if (usuarioVendedor) {
            nombres = usuarioVendedor.nombres;
          }
          return (
            nombres || (
              <Typography.Text type="secondary">Sin Ejecutivo</Typography.Text>
            )
          );
        },
        filterType: fieldTypes.STRING,
        sortable: true
      },
      ...(esAdmin
        ? [
            {
              title: 'Sucursal',
              dataIndex: [
                'cotizacion',
                'usuarioVendedor',
                'sucursal',
                'descripcion'
              ],
              filterType: fieldTypes.STRING,
              sortable: true
            }
          ]
        : []),
      {
        title: 'Estado',
        dataIndex: 'estado',
        filterType: fieldTypes.ENUM,
        filters: Object.keys(estadosSolicitud).map((key) => ({
          text: estadosSolicitud[key],
          value: key
        })),
        sortable: true,
        render: (estado, record) => {
          const estadoUpperCase = toUpperCase(estado);
          let mensajeVerificar = '';
          let proceso = '';
          if (record.mensaje) {
            const error = record.mensaje?.split('::');
            mensajeVerificar = error[1].toString();
            proceso = error[2].toString();
          }
          let color = 'white';
          if (
            estadoUpperCase === 'PENDIENTE' ||
            estadoUpperCase === 'PENDIENTE_DOCUMENTOS' ||
            estadoUpperCase === 'PENDIENTE_AUTORIZACION'
          ) {
            color = 'orange';
          } else if (estadoUpperCase === 'RECHAZADO') {
            color = 'volcano';
          } else if (estadoUpperCase === 'REVISION') {
            color = 'blue';
          } else if (estadoUpperCase === 'VERIFICAR') {
            color = 'yellow';
          } else if (estadoUpperCase === 'AUTORIZACION') {
            color = 'yellow';
            if (!record.asegurado_bcp) {
              mensajeVerificar += '\nVerificar datos del Asegurado'; // con BCP
            }
            if (
              record.cotizacion.id_vehiculo &&
              !record.cotizacion.vehiculo?.vehiculo_bcp &&
              proceso !== 'INSPECCION'
            ) {
              mensajeVerificar += '\nVerificar datos del Vehículo'; //  con BCP
            }
          } else if (estadoUpperCase === 'ARCHIVADO') {
            color = 'gray';
          } else if (estadoUpperCase === 'FINALIZADO') {
            color = 'green';
          } else if (estadoUpperCase === 'PROCESANDO') {
            color = 'yellow';
          }
          if (
            estadoUpperCase !== 'VERIFICAR' &&
            estadoUpperCase !== 'PROCESANDO'
          ) {
            mensajeVerificar = '';
          }
          return (
            ((esAdmin || esAdminAseguradora) && (
              <Tooltip placement="top" title={mensajeVerificar}>
                <Tag
                  color={color}
                  key={estadoUpperCase}
                  icon={
                    (estadoUpperCase === 'VERIFICAR' ||
                      estadoUpperCase === 'PROCESANDO') && (
                      <InfoCircleOutlined />
                    )
                  }
                >
                  {estadoUpperCase}
                </Tag>
              </Tooltip>
            )) || (
              <Tag color={color} key={estadoUpperCase}>
                {estadoUpperCase}
              </Tag>
            )
          );
        }
      },
      {
        title: 'Monto',
        dataIndex: 'monto_total',
        filterType: fieldTypes.NUMERIC,
        sortable: true,
        render: (monto_total, record) => (
          <div style={{ whiteSpace: 'nowrap' }}>
            {formatoMonedaGenerico(record.moneda, monto_total)}
          </div>
        )
      },
      // {
      //   title: 'Tipo',
      //   dataIndex: 'tipo',
      //   filterType: fieldTypes.ENUM,
      //   filters: Object.keys(tiposSolicitud).map((key) => ({
      //     text: tiposSolicitud[key],
      //     value: key
      //   })),
      //   render: (tipo) => {
      //     return esAdmin && <div style={{ whiteSpace: 'nowrap' }}>{tipo}</div>;
      //   }
      // },
      {
        title: 'Lote',
        dataIndex: ['poliza', 'id_poliza_masiva'],
        filterType: fieldTypes.STRING,
        sortable: true
      },
      {
        title: 'Acciones',
        key: 'action',
        width: '10px',
        align: 'left',
        render: (text, record) => {
          let procesoError = '';
          if (record.mensaje) {
            const error = record.mensaje?.split('::');
            procesoError = error[2].toString();
          }
          const { empresa } = record.cotizacion.aseguradoraEmpresa;
          return (
            <Space size="small">
              {getButton(record)}
              {((esAdminAseguradora &&
                record.cotizacion.aseguradoraEmpresa.aseguradora.id ===
                  record.cotizacion.aseguradoraEmpresa.empresa
                    .id_aseguradora) ||
                !esAdminAseguradora) &&
                (record.estado !== 'PENDIENTE' ? (
                  <Tooltip title="Copiar enlace para firmar.">
                    <Button
                      disabled
                      icon={<CopyOutlined />}
                      type="text"
                      size="middle"
                    />
                  </Tooltip>
                ) : (
                  <Tooltip
                    title={
                      record.cotizacion?.producto?.descripcion?.includes(
                        'Carta Verde'
                      )
                        ? 'Copiar enlace para generar carta verde'
                        : 'Copiar enlace para firmar'
                    }
                  >
                    <Button
                      type="text"
                      icon={
                        <CopyOutlined style={{ color: CONFIG.COLOR_PRIMARY }} />
                      }
                      size="middle"
                      onClick={() => handleGetNewToken(record)}
                    />
                  </Tooltip>
                ))}
              {((esAdminAseguradora &&
                record.cotizacion.aseguradoraEmpresa.aseguradora.id ===
                  empresa.id_aseguradora) ||
                !esAdminAseguradora) && (
                <Tooltip
                  title={() => {
                    const viaWhatsapp =
                      empresa.tiene_whatsapp &&
                      record.cotizacion.persona?.via_contacto === 'whatsapp';
                    if (viaWhatsapp) return 'Enviar por Whatsapp';

                    const viaSMS = empresa.tiene_sms;
                    if (viaSMS) return 'Enviar por SMS';

                    return 'Enviar por Correo el enlace para firmar';
                  }}
                >
                  <Button
                    type="text"
                    shape="circle"
                    onClick={() => {
                      if (empresa.tiene_sms || empresa.tiene_whatsapp) {
                        sendSms(record, empresa);
                      } else {
                        sendMail(record);
                      }
                    }}
                    icon={<MessageOutlined />}
                    size="middle"
                    disabled={
                      record.estado === 'PROCESANDO' ||
                      record.cotizacion?.producto?.descripcion?.includes(
                        'Carta Verde'
                      )
                    }
                  />
                </Tooltip>
              )}

              {record.poliza && !record.poliza.manual && (
                <>
                  {(record.estado === 'VERIFICAR' &&
                    (procesoError === 'ALTA_POLIZA' ||
                      procesoError === 'ALTA_POLIZA_SEGU' ||
                      procesoError === 'GENERAR_DEUDA' ||
                      procesoError === 'SUBIR_FOTOS_POLIZA' ||
                      procesoError === 'ENVIO_SEBAOT') && (
                      <Tooltip title="Generar Póliza">
                        <Button
                          type="text"
                          shape="circle"
                          onClick={() => {
                            generarPoliza(record);
                          }}
                          icon={<ReloadOutlined />}
                          size="middle"
                          loading={loading && tokenEnviar === record.token}
                        />
                      </Tooltip>
                    )) ||
                    ((record.estado === 'VERIFICAR' ||
                      record.estado === 'AUTORIZACION') &&
                      record.poliza &&
                      (record.poliza.estado === 'FOTOS_SUBIDAS' ||
                        (record.poliza.estado === 'CREADO' &&
                          record.poliza.id_producto !== 1)) &&
                      (procesoError === 'ALTA_POLIZA_GENERADA' ||
                        procesoError === 'APROBACION_POLIZA') && (
                        <Tooltip title="Aprobar Póliza">
                          <Button
                            type="text"
                            shape="circle"
                            onClick={() => {
                              aprobarPoliza(record);
                            }}
                            icon={<ReloadOutlined />}
                            size="middle"
                            loading={loading && tokenEnviar === record.token}
                          />
                        </Tooltip>
                      )) || (
                      <Button
                        type="text"
                        shape="circle"
                        icon={<ReloadOutlined />}
                        size="middle"
                        disabled
                      />
                    )}
                </>
              )}

              {(esAdminAseguradora || esAdmin) && record.poliza?.manual && (
                <Tooltip title="Subir documentos Póliza">
                  <Button
                    type="text"
                    shape="circle"
                    onClick={() =>
                      handleOpenUrl(`poliza/subir/${record.poliza?.token}`)
                    }
                    icon={<UploadOutlined />}
                    size="middle"
                    disabled={record.estado !== 'PENDIENTE_DOCUMENTOS'}
                  />
                </Tooltip>
              )}
            </Space>
          );
        }
      }
    ];
    setColumns(columnas);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loading, tokenEnviar]);

  const handleGetNewToken = async (data) => {
    setLoading(true);
    const esCV = data.cotizacion?.producto?.descripcion === 'Carta Verde';
    const tokenOriginal = data.token;
    try {
      const response = await instanceRef.instance.post(
        `/tokenExpirables/regenerar-from-token-original?flujo=solicitud&tokenOriginal=${tokenOriginal}`
      );
      if (response.data) {
        const dominio = esCV ? 'generar-cv-publico' : 'firmar-publico';
        navigator.clipboard.writeText(
          `${window.location.origin}/${dominio}/${response.data.message}`
        );
        message.success('Se copió el enlace al portapapeles');
        setLoading(false);
      }
    } catch (err) {
      errorHandler('Error al cargar la solicitud', err);
      setLoading(false);
    }
  };

  return (
    <ResponsiveContainer size="large" style={{ paddingTop: 0 }}>
      {user && user['cognito:groups'].includes('ADMIN') && (
        <Card style={{ marginBottom: 5, textAlign: 'left' }} title="Filtros">
          <Form
            initialValues={{ tipo: 'individual' }}
            scrollToFirstError
            layout="horizontal"
            name="historico"
            autoComplete="off"
            onValuesChange={(values) => {
              setDefaultFilters({
                'poliza.id_poliza_masiva': {
                  value: 'null',
                  filterType: fieldTypes.STRING,
                  filterCondition:
                    values.tipo === 'individual'
                      ? filterConditions.EQUALS
                      : filterConditions.NOT_EQUALS
                }
              });
              setTimeout(() => {
                tableRef.current.reload();
              }, 500);
            }}
          >
            <Row justify="start">
              <Col lg={12} md={12} xs={24}>
                <Form.Item label="Tipo" name="tipo">
                  <Radio.Group>
                    <Radio.Button value="individual">Individual</Radio.Button>
                    <Radio.Button value="masivas">Por lote</Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      )}
      <TableAndFilters
        ref={tableRef}
        withGeneralFilter
        defaultFilters={defaultFilters}
        url="/solicitud"
        title="Solicitudes"
        columns={columns}
        showTable
        hasExportar
        extra={[
          user && user['cognito:groups'].includes('ADMIN') && (
            <Button
              key="solicitud_masiva"
              type="dashed"
              shape="round"
              icon={<UploadOutlined />}
              size="middle"
              onClick={() => handleOpenUrl(`poliza/masiva`)}
              style={styles.menuAction}
            >
              Subir lote
            </Button>
          ),
          user && user['cognito:groups'].includes('ADMIN') && (
            <Button
              key="poliza_masiva"
              type="dashed"
              shape="round"
              icon={<ReloadOutlined />}
              size="middle"
              onClick={() => showModalPolizaMasiva()}
              style={styles.menuAction}
            >
              Procesar lote
            </Button>
          ),
          user && user['cognito:groups'].includes('ADMIN') && (
            <Button
              key="poliza_masiva_aprobar"
              type="dashed"
              shape="round"
              icon={<ReloadOutlined />}
              size="middle"
              onClick={() => showModalAprobarExtranjeros()}
              style={styles.menuAction}
            >
              Aprobar extranjeros
            </Button>
          )
        ]}
      />

      <Modal
        title="Generar Póliza Masiva"
        open={visiblePolizaMasiva}
        onOk={handleOkPolizaMasiva}
        onCancel={handleCancelPolizaMasiva}
        confirmLoading={loadingMasiva}
      >
        <Form
          form={formPolizaMasiva}
          layout="vertical"
          name="polizaMasivaForm"
          style={styles.form}
        >
          <Form.Item
            label="Nro Lote"
            name="numero_lote"
            rules={[{ required: true, message: 'Requerido' }]}
          >
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Aprobar extranjeros en Póliza Masiva"
        open={visibleAprobarExtranjeros}
        onOk={handleOkAprobarExtranjeros}
        onCancel={handleCancelAprobarExtranjeros}
        confirmLoading={loadingMasiva}
      >
        <Form
          form={formAprobarExtranjeros}
          layout="vertical"
          name="formAprobarExtranjeros"
          style={styles.form}
        >
          <Form.Item
            label="Nro Lote"
            name="numero_lote"
            rules={[{ required: true, message: 'Requerido' }]}
          >
            <Input placeholder="Ingrese un valor" />
          </Form.Item>
        </Form>
      </Modal>
    </ResponsiveContainer>
  );
}

export default SolicitudList;
